import { Mesh, Object3D } from "three"
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry'
import gsap from 'gsap'
import C from "./Constants"
export default class
{
    constructor(_options)
    {
        this.database = _options.database
        this.font = _options.font
        this.time = _options.time
        this.ui = _options.ui
        this.camera = _options.camera
        this.materials = _options.materials
        this.layout = _options.layout
        this.bottles = _options.bottles
        this.forest = _options.forest

        this.textsArray = []
        this.progressiveId = -1
        this.activeId = this.progressiveId

        this.container = new Object3D()
        this.container.name = 'texts_container'

        this.ongoingAnimation = false
    }

    highlightMesh(pointedItem, pointedPos, showText)
    {
        if(pointedItem === undefined) return

        this.ui.interruptAutoclick()

        // Higlight lot mesh
        const meshes = this.getMeshes(pointedItem.id)

        for(let mesh of meshes)
        {
            mesh.userData.originalMaterial = mesh.material

            if(mesh.material === this.materials.items.treesMat || mesh.material === this.materials.items.buildingMat)
            {
                mesh.material = this.materials.items.plainHighlightedMat
            }
            else
            {
                mesh.material = this.materials.items.lotHighlightedMat
            }
        }

        // Show text
        if(showText) this.showText(pointedItem, pointedPos)
    }

    unlightMesh(pointedItemId)
    {
        if(!pointedItemId) return

        // Unlight lot mesh
        const meshes = this.getMeshes(pointedItemId)
        for(let mesh of meshes)
        {
            mesh.material = mesh.userData.originalMaterial
        }

        // Dispose text
        this.textAnimateOut(this.activeId, C.RAYCAST.textAnimDuration, 0)
    }

    getMeshes(itemId)
    {
        const result = this.layout.getMeshes(itemId)
        return (result === undefined || result.length < 1) ? [this.forest] : result
    }

    showText(item, pointedPos)
    {
        if(this.textsArray.find(x => x.id === this.activeId !== undefined))
        {
            this.textAnimateOut(this.activeId, C.RAYCAST.textAnimDuration, 0)
        }

        this.addTextToArray(item)

        // Set position to raycasted intersection
        this.textsArray.find(x => x.id === this.activeId).mesh.position.set(
            pointedPos.x,
            pointedPos.y - C.RAYCAST.textStartY,
            pointedPos.z
        )

        // Set rotation to face the camera
        this.time.on('tick', () =>
        {
            const text = this.textsArray.find(x => x.id === this.activeId)
            if(text !== undefined) text.mesh.lookAt(this.camera.instance.position)
        })

        // Animate text
        gsap.to(this.textsArray.find(x => x.id === this.activeId).mesh.position, { duration: C.RAYCAST.textAnimDuration, y: pointedPos.y + C.RAYCAST.textEndY })
    }

    addTextToArray(item)
    {
        this.textOptions =
        {
            font: this.font,
            size: 0.05,
            height: 0.00, // 0.015,
            curveSegments: 6
        }

        // Create text geometry
        const displayName = this.database.getDisplayName(item.id)
        const textGeo = new TextGeometry(displayName, this.textOptions)
        textGeo.center()

        // Create text mesh
        const textMesh = new Mesh(textGeo, this.materials.items.basicBlackMat)

        // Create combinedMesh
        const text = new Object3D()
        text.add(textMesh)

        // Add text to the texts array
        this.textsArray.push(
        {
            id: ++this.progressiveId,
            mesh: text,
            deleting: false
        })
        this.activeId = this.progressiveId
        this.container.add(text)
    }

    textAnimateOut(id, duration, delay)
    {
        if(this.textsArray.findIndex(x => x.id === id) === -1) return

        const text = this.textsArray.find(x => x.id === id)
        if(text.deleting) return
        text.deleting = true

        gsap
            .to(text.mesh.position, { duration: duration, delay: delay, y: text.mesh.position.y - C.RAYCAST.textStartY })
            .then(() =>
            {
                this.disposeText(id)
            })
    }

    disposeText(id)
    {
        const index = this.textsArray.findIndex(x => x.id === id)
        this.container.remove(this.textsArray[index].mesh)
        this.textsArray[index].mesh.clear()
        this.textsArray.splice(index, 1)
    }


    showBottle(itemId, pos)
    {
        // Text disappear down
        this.textAnimateOut(this.activeId, C.CAMERA.clickAnimDuration, C.CAMERA.clickAnimDuration * 0.25 * 2)

        this.wine = this.database.getWineFromId(itemId)

        if(this.wine === undefined) return

        // Create bottle
        this.bottles.showBottle(this.wine, pos)
    }
}